import Grid2 from '@mui/material/Unstable_Grid2';

import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type { Contentful, FeaturedComponent } from '@/contentful';
import { ContentStyle, TextAlignment } from '@/contentful/types';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './HighlightText.styles';

export interface HighlightTextContent extends Contentful {
  fields: {
    id: string;
    style?: ContentStyle;
    textAlignment?: TextAlignment.Left | TextAlignment.Center;
    eyebrow?: string;
    headline?: string;
  };
}

export type HighlightTextProps = FeaturedComponent<{
  content: HighlightTextContent;
}>;

export default function HighlightText({
  isFeatured,
  content: {
    fields: { id, style, textAlignment, eyebrow, headline },
  },
}: HighlightTextProps) {
  const isOnDark = style === ContentStyle.OnDark;
  const { classes, cx } = useStyles({ isOnDark });
  const { classes: globalClasses } = useGlobalStyles({ fixed: false });

  const isLeftAligned = textAlignment === TextAlignment.Left;
  const gridSizes = isLeftAligned
    ? { lg: 7, md: 6, sm: 12, xs: 12 }
    : { lg: 10, md: 10, sm: 12, xs: 12 };
  const gridOffsets = isLeftAligned
    ? { lgOffset: 0, mdOffset: 0, smOffset: 0, xsOffset: 0 }
    : { lgOffset: 1, mdOffset: 1, smOffset: 0, xsOffset: 0 };

  return (
    <SpacingContainer className={classes.container} isFeatured={isFeatured}>
      <GridContainer2 fixed wrapperProps={{ id }}>
        <Grid2 {...gridSizes} {...gridOffsets}>
          {eyebrow && (
            <div
              className={cx(globalClasses.eyebrow, classes.eyebrow, {
                [classes.textCenter]: textAlignment === TextAlignment.Center,
              })}
            >
              {eyebrow}
            </div>
          )}
          {headline && (
            <div
              className={cx(globalClasses.h1, classes.headline, {
                [classes.textCenter]: textAlignment === TextAlignment.Center,
              })}
            >
              {headline}
            </div>
          )}
        </Grid2>
      </GridContainer2>
    </SpacingContainer>
  );
}
